<template>
  <PageTemplate>
    <div class="row">
      <div class="col-md-6">
        <h1>
          User Profile
          <v-button
            color="transparent"
            @click="edit"
          >
            <v-icon
              v-if="isActive"
              size="lg"
              type="edit"
            />
          </v-button>
        </h1>
      </div>
      <div
        class="col-md-6"
        style="display:flex; justify-content:flex-end;"
      >
        <v-button
          v-if="isTAUser()"
          size="xl"
          style="float: right; height:50px;"
          :disabled="disableMarkProfileUptodate"
          has-min-width
          @click="markProfileUptodate"
        >
          Mark Profile is up to date
        </v-button>
      </div>
    </div>
    <div
      v-if="isTAUser()"
      class="warning-msg warning-local"
    >
      To Mark Profile up to date. Please confirm profile details and view and confirm competencies.
    </div>
    <div
      v-if="showWarning()"
      class="warning-msg"
    >
      Warning: Either selected user is not a TA User or if it's TA User then It's profile info may be missing.
      <br><b>Showing Sys Admin user profile view.</b>
    </div>
    <v-card :title="currentUser.first_name + ' ' + currentUser.last_name">
      <template #header>
        <v-dropdown is-right>
          <v-icon
            size="lg"
            type="ellipsis-v"
          />
          <template #dropdown-menu>
            <v-dropdown-item @click="activateModal = true">
              {{ isActive ? 'Deactivate' : 'Activate' }} User Profile
            </v-dropdown-item>
            <v-dropdown-item @click="deleteUser">
              Delete
            </v-dropdown-item>
          </template>
        </v-dropdown>
      </template>
      <template v-if="!isTAAdmin() || !isTAUserAndHasUserInfo()">
        <h4>
          Personal Details
          <v-button
            color="transparent"
            @click="edit"
          >
            <v-icon
              v-if="isActive"
              size="lg"
              type="edit"
            />
          </v-button>
        </h4>
        <v-data-list :data="personalDetails" />
      </template>
      <template v-else>
        <v-profile-ta
          :current-user="currentUser"
          profile-view-type="ADMIN"
          @viewedCompetencyPDF="(res)=>disableMarkProfileUptodate = false"
        />
      </template>
      <template
        v-if="currentUser.hasOwnProperty('roles') && currentUser.roles.map(el => el.name).includes(constants.NATA_ROLE_AR)"
      >
        <h4 style="position:relative;">
          Site/Facility Access Details
          <v-button
            color="transparent"
            @click="edit"
          >
            <v-icon
              v-if="isActive"
              size="lg"
              type="edit"
            />
          </v-button>
        </h4>
        <div
          v-for="(access,index) in accessDetails"
          :key="index"
          style="position: relative;"
        >
          <v-data-list :data="access" />
          <div style="position: absolute; top: 20px; left: 50px;">
            <fieldset class="fieldset">
              <v-checkbox
                :id="`facilityAr_${index}`"
                :value="index"
                :checked="isCurrentUserIsPrimaryArOfFacility(index)"
                @change="updateFacilityPrimaryAr"
              >
                <span
                  style="position: absolute; top: 8px; min-width: 250px;"
                >
                  <span
                    class="input-help"
                    style="color:grey; font-size: 8px; position: absolute; top: -8px;"
                  >Primary Ar</span>
                  {{ getFacilityPrimaryArName(index) }}
                </span>
              </v-checkbox>
            </fieldset>
          </div>
        </div>
      </template>
      <template>
        <div v-if="currentUser.hasOwnProperty('roles') && currentUser.roles.map(el => el.name).includes(constants.NATA_ROLE_CM)">
          <h4>Forum</h4>
          <fieldset class="fieldset">
            <v-checkbox
              id="writePermission"
              value="committeePermissions.write"
              :checked="committeePermissions.write"
              @change="updateForumPermissions"
            >
              <span>User can Add Discussions to Committee Forums</span>
            </v-checkbox>
            <span
              class="input-help"
              style="color:grey"
            >Automatically set users write access</span>
          </fieldset>
        </div>
      </template>
      <div
        v-if="currentUser.hasOwnProperty('roles') && currentUser.roles.map(el => el.name).includes(constants.NATA_ROLE_CM)"
        class="mb-4"
      >
        <h4>
          Selected Committee
          <v-button
            color="transparent"
            @click="edit"
          >
            <v-icon
              v-if="isActive"
              size="lg"
              type="edit"
            />
          </v-button>
        </h4>
        <h5>Committees</h5>
        <div
          v-for="com in userCommittees"
          :key="com.name"
        >
          {{ com.name }}
          <small
            v-if="com.isAdmin && isActive"
            type="check"
          >
            (admin)
          </small>
        </div>
      </div>
      <template>
        <h4>
          Subscriptions
          <v-button
            color="transparent"
            @click="edit"
          >
            <v-icon
              v-if="isActive"
              size="lg"
              type="edit"
            />
          </v-button>
        </h4>
        <!--        REFACTOR SUBSCRIPTIONS -->
        <div v-if="selectedGeneralPublication.length > 0">
          <v-list
            :items="selectedGeneralPublication"
          />
        </div>
      </template>
    </v-card>
    <v-modal
      v-if="activateModal"
      @close="closeModal"
    >
      <template #header>
        {{ isConfirmed ? 'Successful' : 'Confirmation' }}
      </template>
      <template v-if="isConfirmed">
        You have successfully {{ isActive ? 'activated' : 'deactivated' }} {{ currentUser.first_name }} {{ currentUser.last_name }}’s profile.
      </template>
      <template v-else-if="isDeleteAction">
        <div>
          Are you sure you want to delete {{ currentUser.first_name }} {{ currentUser.last_name }}?
        </div>
      </template>
      <template v-else-if="isActive">
        <div v-if="currentUser.committeeAdmin.map(el => el.name).length > 0">
          {{ currentUser.first_name }} {{ currentUser.last_name }} is an Admin of {{ currentUser.committeeAdmin.length
          }} committees. If you deactivate his/her account, those {{ currentUser.committeeAdmin.length }} committees
          will not have any
          Admin. Are you sure you want to continue deactivating?
        </div>
        <div v-else>
          Are you sure you want to deactivate {{ currentUser.first_name }} {{ currentUser.last_name }}?
        </div>
      </template>
      <template v-else>
        Are you sure you want to activate {{ currentUser.first_name }} {{ currentUser.last_name }}’s profile?
      </template>
      <template #footer>
        <v-button-group is-right>
          <v-button
            v-if="!isConfirmed"
            size="lg"
            has-min-width
            @click="actionConfirmed"
          >
            Yes, continue
          </v-button>
          <v-button
            :color="isConfirmed ? 'primary' : 'secondary'"
            size="lg"
            has-min-width
            @click="closeModal"
          >
            {{ isConfirmed ? 'Got it' : 'Cancel' }}
          </v-button>
        </v-button-group>
      </template>
    </v-modal>
  </PageTemplate>
</template>
<script>
  import PageTemplate from "@/templates/Page";
  import Card from "@/molecules/Card";
  import Dropdown from "@/molecules/Dropdown";
  import Icon from "@/atoms/Icon";
  import Modal from "@/atoms/Modal";
  import Button from "@/atoms/Button";
  import DataList from "@/atoms/DataList";
  import Checkbox from "@/atoms/Checkbox";
  import List from "@/molecules/List";
  import ButtonGroup from "@/molecules/ButtonGroup";
  import DropdownItem from "@/atoms/DropdownItem";
  import ProfileTA from "../ProfileTA.vue";
  import {buildBreadCrumb, buildDefinitionList} from "@/common/tableFunctions"
  import {mapState} from "vuex";
  import {GET_ALL_USERS, GET_USER_INFO, ACTIVATE_USER, DEACTIVATE_USER, DELETE_USER, UPDATE_COMMITTEE_PERMISSIONS } from "../../store/actions.type";
  import constants from "../../common/constants";
  import routes from "@/common/routes";
  import ApiService from "@/common/apiService";
  import Spinner from "@/atoms/Spinner";

  export default {
    name: "Users",
    components: {
      "v-card": Card,
      "v-dropdown": Dropdown,
      "v-icon": Icon,
      "v-list": List,
      "v-dropdown-item": DropdownItem,
      "v-button-group": ButtonGroup,
      "v-button": Button,
      "v-modal": Modal,
      "v-data-list": DataList,
      "v-checkbox": Checkbox,
      "v-profile-ta": ProfileTA,
      'v-button': Button,
      PageTemplate
    },
    data: () => ({
      activateModal: false,
      isConfirmed: false,
      isActive: false,
      isDeleteAction: false,
      disableMarkProfileUptodate: true,
      accessDetails: [],
      facilitiesPrimaryAr: []
    }),
    computed: {
      ...mapState({
        users: state => state.userRequest.users,
        currentUser: state => state.userRequest.currentUser,
        // accessDetails: state => state.userRequest.accessDetails,
        // facilitiesPrimaryAr: state => state.userRequest.facilitiesPrimaryAr,
        committees: state => state.userRequest.committees,
        subscriptions: state => state.userRequest.subscriptions,
        committeePermissions: state => state.userRequest.committeePermissions
      }),
      personalDetails: function () {
        if (this.currentUser.id) {
          let details = [];
          details['User Type'] = this.currentUser.roles.map(function (val) {
            return constants.USER_ROLES.find(f => f.name === val.name).fullName
          }).join(',')
          details['First Name'] = this.currentUser.first_name;
          details['Last Name'] = this.currentUser.last_name || 'None';
          details['Position Title'] = this.currentUser.title || 'None';
          details['Phone'] = this.currentUser.mobile_number || 'None';
          details['Email'] = this.currentUser.email;
          details['Address'] = this.currentUser.address || 'None';
          details['Suburb'] = this.currentUser.suburb || 'None';
          details['State'] = this.currentUser.state || 'None';
          details['Country'] = this.currentUser.country || 'None';
          details['Post Code'] = this.currentUser.postcode || 'None';
          details['User ID'] = this.currentUser.resource_id || 'None';
          return buildDefinitionList(details);
        } else {
          return [];
        }
      },
      userCommittees: function () {
        if (this.committees.length > 0) {
          let arr = [];
          let com_admin_ids = (this.currentUser.committeeAdmin);
          let coms = this.committees[0].desc.split(',')
          for (let i in coms) {
            let t = {}
            t.name = coms[i]
            t.isAdmin = com_admin_ids.map(el => el.name).includes(coms[i])
            arr.push(t)
          }
          return arr;
        } else {
          return [];
        }
      },
      selectedGeneralPublication:{
        get(){
          let subs = this.subscriptions.map( (sub) => {
            return {
              "link": "",
              "value": sub.name
            };
          });
          return subs;
        },
        set(val) {
          return val;
        }
      },
    },
    watch: {
      users: {
        handler: function (val) {
          this.getUser(this.$route.params.id);
          this.getUserInfo(this.$route.params.id);
        }
      }
    },
    created() {
      this.constants = constants;
    },
    mounted() {
      this.updateBreadCrumb();
      if (this.users.length === 0) {
        this.getUsers();
      } else {
        this.getUser(this.$route.params.id);
        this.getUserInfo(this.$route.params.id);
      }
    },
    methods: {
      updateBreadCrumb: function () {
        let breadcrumbs = [];
        breadcrumbs['All Users'] = routes.ADMIN.USERS;
        breadcrumbs['User Profile'] = '';
        this.breadcrumbs = buildBreadCrumb(breadcrumbs);
        this.$store.dispatch('updateBreadCrumbAction', buildBreadCrumb(breadcrumbs));
      },
      closeModal: function () {
        this.activateModal = false;
        this.isConfirmed = false;
        this.isDeleteAction = false;
      },
      deactivate: function () {
        this.$store.dispatch(DEACTIVATE_USER, this.currentUser.id).then(response => {
          if (response.success) {
            this.isConfirmed = true;
            this.isActive = false;
          } else {
            this.$notify({
              title: 'Error:',
              text: response.response.data.message,
              type: 'error'
            })
          }
        });

      },
      activate: function () {
        this.$store.dispatch(ACTIVATE_USER, this.currentUser.id).then(response => {
          this.isConfirmed = true;
          this.isActive = true;
        }).catch(error => {
          this.$notify({
            title: 'Error:',
            text: error.response.data.message,
            type: 'error'
          })
        });
      },
      getUsers() {
        this.$store.dispatch(GET_ALL_USERS)
      },
      getUser(id) {
        this.$store.dispatch('updateCurrentUser', id).then(resposne => {
          this.isActive = this.currentUser.activated !== 0;
        });
      },
      async getUserInfo(id) {
        await this.$store.dispatch(GET_USER_INFO, id);
        this.accessDetails = this.$store.state.userRequest.accessDetails;
        this.facilitiesPrimaryAr = this.$store.state.userRequest.facilitiesPrimaryAr
      },
      edit() {
        this.$router.push(routes.ADMIN.EDIT_PERSONAL_DETAILS + this.currentUser.id)
      },
      deleteUser() {
        this.isDeleteAction = true;
        this.isConfirmed = false;
        this.activateModal = true;
      },
      deleteUserAction() {
        this.$store.dispatch(DELETE_USER, this.currentUser.id)
          .then(response => {
            this.closeModal();
            this.$notify({
              title: 'Success:',
              text: 'The user is deleted from system!',
              type: 'success'
            });
            this.$router.push(routes.ADMIN.USERS);
          })
          .catch(error => {
            this.$notify({
              title: 'Error:',
              text: 'Delete user error!',
              type: 'error'
            })
          })
      },
      actionConfirmed() {
        if(this.isDeleteAction) {
          this.deleteUserAction();
        }else {
          if(this.isActive)
            this.deactivate();
          else
           this.activate();
        }
      },
      updateForumPermissions(event) {
        let perms = {};
        if(event.target.id === 'writePermission'){
          perms['write'] = event.target.checked;
        }
        this.$store.dispatch(UPDATE_COMMITTEE_PERMISSIONS, [this.currentUser.id,perms])
          .then(response => {
            this.closeModal();
            this.$notify({
              title: 'Success:',
              text: 'Forum permissions updated.',
              type: 'success'
            });
          })
          .catch(error => {
            this.$notify({
              title: 'Error:',
              text: 'Forum permissions did not update successfully.',
              type: 'error'
            })
          })
      },
      markProfileUptodate() {
        ApiService.get(`/admin/ta/markprofileuptodate/${this.currentUser.id}`)
          .then(response => {
            if(response.data.data)
              this.$notify({
                  title: 'Success',
                  text: 'Successfully marked profile as up to date.',
                  type: 'success'
                });
            else
              this.$notify({
                  title: 'Error',
                  text:'Unable to mark profile as up to date. Please contact administrator.',
                  type: 'error'
                });
          })
          .catch(error => {
            this.$notify({
                title: 'Error',
                text:'Unable to mark profile as up to date. Please contact administrator.',
                type: 'error'
              });
          });
      },
      isTAUserAndHasUserInfo() {
        return this.isTAUser() && this.currentUser.user_info;
      },
      isTAUser() {
        if(this.currentUser.roles)
          return this.currentUser.roles.filter(ele => ele.id == constants.NATA_ROLE_TA_ID).length > 0;
        return false;
      },
      showWarning() {

        return  this.isTAAdmin() && !this.isTAUserAndHasUserInfo();
      },
      isTAAdmin() {
        const current_role = localStorage.getItem(constants.CURRENT_ROLE);
        return current_role === constants.NATA_ROLE_TA_ADMIN;
      },
      getFacilityPrimaryArName(index) {
        if(this.facilitiesPrimaryAr && this.facilitiesPrimaryAr[index].facilityMappedPrimaryAr)
          return this.facilitiesPrimaryAr[index].facilityMappedPrimaryAr.first_name+' '+this.facilitiesPrimaryAr[index].facilityMappedPrimaryAr.last_name;
        return "Not set";
      },
      isCurrentUserIsPrimaryArOfFacility(index) {
        if(this.facilitiesPrimaryAr && this.facilitiesPrimaryAr[index].facilityMappedPrimaryAr) {
          return this.facilitiesPrimaryAr[index].facilityMappedPrimaryAr.id == this.currentUser.id
        }
        return false;
      },
      updateFacilityPrimaryAr(evt) {
        const facilityId = this.facilitiesPrimaryAr[evt.target.value].facilityId;
        
        ApiService.get(`/facility/update-primary-ar/${facilityId}/${this.currentUser.id}/${evt.target.checked}`)
          .then(response => {
            if(response.data.data) {
              if(evt.target.checked) {
                if(this.facilitiesPrimaryAr[evt.target.value] && this.facilitiesPrimaryAr[evt.target.value].facilityMappedPrimaryAr) {
                  this.facilitiesPrimaryAr[evt.target.value].facilityMappedPrimaryAr.first_name = this.currentUser.first_name;
                  this.facilitiesPrimaryAr[evt.target.value].facilityMappedPrimaryAr.last_name = this.currentUser.last_name;
                }else {
                  this.facilitiesPrimaryAr[evt.target.value] = {
                    facilityMappedPrimaryAr: this.currentUser
                  }
                }
                
                
              }else {
                this.facilitiesPrimaryAr[evt.target.value].facilityMappedPrimaryAr.first_name = 'Not';
                this.facilitiesPrimaryAr[evt.target.value].facilityMappedPrimaryAr.last_name = 'Set';
              }
              this.$notify({
                  title: 'Success',
                  text: 'Successfully Updated Primary Ar.',
                  type: 'success'
                });
            }
            else
              this.$notify({
                  title: 'Error',
                  text:'Unable to Update facility primary AR.',
                  type: 'error'
                });
          })
          .catch(error => {
            this.$notify({
                title: 'Error',
                text:'Unable to Update facility primary AR.'+error,
                type: 'error'
              });
          });
          this.getUserInfo(this.currentUser.id);
      }
    }
  }
</script>
<style ang="scss">
.warning-msg {
    border-color: #0076ff;
    color: #0076ff;
    background-color: mix(white, red, 95%);
}
</style>
